// extracted by mini-css-extract-plugin
export var completionBody = "_cg-2";
export var completionCard = "_cg-0";
export var completionFooter = "_cg-3";
export var completionTitle = "_cg-1";